import * as React from "react";
const IconCloseCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M33.4 32 61.7 3.7c.4-.4.4-1 0-1.4s-1-.4-1.4 0L32 30.6 3.7 2.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4L30.6 32 2.3 60.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3L32 33.4l28.3 28.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4z" />
  </svg>
);
export default IconCloseCopy;
